import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import debounce from 'lodash/debounce';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import Predictions from './predictions';
import { findPredictions, getPredictionAddress } from './helpers';

import './styles.scss';

export default function AutocompletedAddressFormGroup({
  address, city, className, country, state, zip, onChange, ...props
}) {
  const [predictions, setPredictions] = useState([]);

  const autocomplete = useCallback(
    debounce(async (fields) => {
      if (fields.address) {
        setPredictions(await findPredictions(fields));
      }
    }, 500),
    []
  );

  function changeAddress(address) {
    onChange({ address });
    autocomplete({ address, city, country, state, zip });

    if (!address) {
      clearPredictions();
    }
  }

  async function selectPrediction(prediction) {
    clearPredictions();
    onChange(await getPredictionAddress(prediction));
  }

  function clearPredictions(event) {
    setPredictions([]);
    event?.nativeEvent?.stopImmediatePropagation();
  }

  return (
    <div className="address-autocompletion">
      <ManagedFormGroup
        className={classNames('address-autocompletion__form-group', className)}
        label="Address"
        {...props}
        name="address"
        value={address}
        onKeyDown={event => event.key === 'Escape' && clearPredictions(event)}
        onValueChange={changeAddress}
      />

      <Predictions
        predictions={predictions}
        onSelect={selectPrediction}
      />
    </div>
  );
}

AutocompletedAddressFormGroup.propTypes = {
  address: PropTypes.string,
  city: PropTypes.string,
  className: PropTypes.string,
  country: PropTypes.object,
  state: PropTypes.string,
  zip: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
